import { PaginationList } from 'best-modules/components/server-table/types'
import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import {
  Organization,
  OrganizationCredentials,
} from '@/utils/types/organization'

const organizationList = (
  query: Query
): Promise<PaginationList<Organization>> => {
  return sendRequest({
    name: 'organizationList',
    method: 'get',
    url: {
      url: '/json/organization',
      query,
    },
  })
}

const createOrganization = (
  credentials: OrganizationCredentials
): Promise<Organization> => {
  return sendRequest({
    name: 'createOrganization',
    method: 'put',
    url: '/json/organization',
    payload: credentials,
  })
}

const updateOrganization = (
  organizationId: number,
  credentials: OrganizationCredentials
): Promise<Organization> => {
  return sendRequest({
    name: 'updateOrganization',
    method: 'put',
    url: `/json/organization/${organizationId}`,
    payload: credentials,
  })
}

const deleteOrganization = (id: number): Promise<Organization> => {
  return sendRequest({
    name: 'deleteOrganization',
    method: 'delete',
    url: `/json/organization/${id}`,
  })
}

export {
  organizationList,
  deleteOrganization,
  updateOrganization,
  createOrganization,
}
